var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Modal } from 'antd';
import { action, observable } from 'mobx';
import services from 'src/shared/services/services';
var default_1 = /** @class */ (function () {
    function default_1() {
    }
    default_1.prototype.getUser = function () {
        var _this = this;
        return services.Auth.getUser().then(function (c) { return (_this.user = c); });
    };
    default_1.prototype.hasRole = function (role) {
        return this.user.roles.some(function (c) { return c.toLowerCase() === role; });
    };
    default_1.prototype.login = function (userName, password, isPersistent) {
        return services.Auth.login(userName, password, isPersistent, location.pathname.replace('/', ''));
    };
    default_1.prototype.logout = function () {
        var _this = this;
        Modal.confirm({
            title: 'Çıkış yapmak istediğinizden emin misiniz?',
            onOk: function () {
                services.Auth.logout().then(function () {
                    if (_this.hasRole('osb yetkilisi')) {
                        location.href = '/osb';
                    }
                    else {
                        location.href = '/fka';
                    }
                });
            }
        });
    };
    __decorate([
        observable
    ], default_1.prototype, "user", void 0);
    __decorate([
        action
    ], default_1.prototype, "getUser", null);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/stores/AuthStore.ts
// module id = 503
// module chunks = 0